import { useContext, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import ddt from '@wix/da-ddt';
// import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MeasuredCookieType, ScreenSizeContext } from '../../Measured';
import { hasCookie } from '../../Measured/redux/selectors';
/* import DeviationMediaService from '../../utils/DeviationMediaService';
import { isVisualDeviation } from '../../DeviationViews/_helpers';
import { clamp } from '../../utils/math';
import { useDuperbrowseViewType } from '../../Duperbrowse/DuperbrowseViewContext'; */
var logger = ddt.createLogger('artstage');
function useIsFirstDeviationAfterSSR(deviation) {
    // this is a bit wacky, but we want to ensure we never recalc the stage for the first deviation after SSR
    // so here we check if this was the first deviation rendered in the component's lifecycle
    // combined with the duperbrowse check, should be Close Enough(tm)
    // we also take note if cookies existed, so important to have this hook run before the cookies get updated
    var isFirstDeviation = useRef(true);
    var firstRenderDeviationId = useRef(deviation.deviationId);
    var hadCookie = useSelector(function (state) {
        return hasCookie(state, MeasuredCookieType.SCREEN_WIDTH);
    });
    var firstDeviationHadCookie = useRef(hadCookie);
    if (isFirstDeviation.current &&
        firstRenderDeviationId.current !== deviation.deviationId) {
        isFirstDeviation.current = false;
    }
    return {
        isFirstDeviation: isFirstDeviation.current,
        hadCookie: firstDeviationHadCookie.current,
    };
}
function calculateFixedStageSize(_a) {
    var screenWidth = _a.width, _b = _a.height, screenHeight = _b === void 0 ? 640 : _b;
    var targetHeight = screenHeight - 280;
    var minHeight = 230;
    var stageHeight = Math.max(targetHeight, minHeight);
    return {
        containerSize: {
            width: screenWidth,
            height: stageHeight,
        },
        contentSize: {
            width: screenWidth,
            height: stageHeight,
        },
    };
}
/*
function calculateDynamicStageSize(deviation: PapiDeviation, screenDims: Dims) {
  const fv = DeviationMediaService.getLargestFullview(deviation);
  if (!fv.width || !fv.height) {
    logger.log('Sizing not avialable for stage scaling', fv);
    return calculateFixedStageSize(screenDims);
  }
  const { width: screenWidth, height: screenHeight } = screenDims;

  logger.log('Adjusting stage height to content', fv);
  const aspect = fv.width / fv.height;
  const maxHeight = screenHeight - 280;
  const minHeight = 230;
  const scaledHeight = clamp(screenWidth / aspect, minHeight, maxHeight);

  logger.log('Scaled height', scaledHeight);
  return {
    containerSize: {
      width: screenWidth,
      height: scaledHeight,
    },
    contentSize: {
      width: screenWidth,
      height: scaledHeight,
    },
  };
} */
export function useMobileStage(ref, deviation) {
    var _a, _b;
    var _c = useIsFirstDeviationAfterSSR(deviation), hadCookie = _c.hadCookie, isFirstDeviation = _c.isFirstDeviation;
    // const { isLoggedIn } = useContext(SessionContext);
    // const { isInDuperbrowse } = useDuperbrowseViewType();
    var _d = useContext(ScreenSizeContext), screenHeight = _d.height, screenWidth = _d.width;
    // ScreenSizeContext is not reliable for shrinking the width after screen
    // rotation, sooo we still need to measure a lil bit
    // we kinda relying on the context updating on resize for triggering a re-calc here
    var width = typeof window === 'undefined' && hadCookie
        ? screenWidth
        : (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) !== null && _b !== void 0 ? _b : screenWidth;
    var stageSize = useMemo(function () {
        // First deviation without cookie must be the default stage size
        if (!hadCookie && isFirstDeviation) {
            logger.log('No cookie');
            return calculateFixedStageSize({ width: width });
        }
        // We can do dynamic if it's visual art and:
        // - either fully client side (duperbrowse and/or not the first deviation)
        // - or we have cookie and are logged in
        /* disabling for now; if it remains unused clean up along with mobile_stage_height
        if (
          isVisualDeviation(deviation) &&
          ((isLoggedIn && hadCookie) || isInDuperbrowse || !isFirstDeviation)
        ) {
          logger.log('Dynamic height', {
            isLoggedIn,
            hadCookie,
            isInDuperbrowse,
            isFirstDeviation,
          });
          return calculateDynamicStageSize(deviation, {
            width,
            height: screenHeight,
          });
        }*/
        logger.log('Fixed height', {
            // isLoggedIn,
            hadCookie: hadCookie,
            // isInDuperbrowse,
            isFirstDeviation: isFirstDeviation,
        });
        return calculateFixedStageSize({ width: width, height: screenHeight });
    }, [
        hadCookie,
        isFirstDeviation,
        // deviation,
        // isLoggedIn,
        // isInDuperbrowse,
        width,
        screenHeight,
    ]);
    return stageSize;
}
//# sourceMappingURL=useMobileStage.js.map